// Basit global fiyat depolama servisi
// - Firebase Firestore varsa onu kullanır (gerçek zamanlı ve global)
// - Env yoksa localStorage'a düşer (mevcut davranış)

let firebaseModules = null; // firestore modülleri
let firebaseAuthModules = null; // auth modülleri
let firestore = null;
let auth = null;
let pricesDocRef = null;
let isFirebaseReady = false;

const STORAGE_KEY = 'bulvar_menu_prices';

function hasFirebaseConfig() {
  return !!(
    process.env.REACT_APP_FIREBASE_API_KEY &&
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN &&
    process.env.REACT_APP_FIREBASE_PROJECT_ID
  );
}

async function ensureFirebase() {
  if (!hasFirebaseConfig()) return false;
  if (isFirebaseReady) return true;

  // Dinamik import (paket kurulu olmalı)
  const [appPkg, firestorePkg, authPkg] = await Promise.all([
    import('firebase/app'),
    import('firebase/firestore'),
    import('firebase/auth')
  ]);
  const { initializeApp } = appPkg;
  const { getFirestore, doc, getDoc, setDoc, onSnapshot } = firestorePkg;
  const { getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut } = authPkg;

  const appConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  };

  const app = initializeApp(appConfig);
  firebaseModules = { onSnapshot, getDoc, setDoc, doc };
  firestore = getFirestore(app);
  auth = getAuth(app);
  firebaseAuthModules = { onAuthStateChanged, signInWithEmailAndPassword, signOut };
  pricesDocRef = doc(firestore, 'config', 'prices');
  isFirebaseReady = true;
  return true;
}

export async function getPrices() {
  try {
    const ok = await ensureFirebase();
    if (ok) {
      const snap = await firebaseModules.getDoc(pricesDocRef);
      return snap.exists() ? snap.data() : {};
    }
  } catch (e) {
    console.warn('Firebase getPrices hata:', e);
  }
  // Fallback: localStorage
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved ? JSON.parse(saved) : {};
  } catch {
    return {};
  }
}

export async function savePrices(prices) {
  try {
    const ok = await ensureFirebase();
    if (ok) {
      await firebaseModules.setDoc(pricesDocRef, prices, { merge: true });
      return true;
    }
  } catch (e) {
    console.warn('Firebase savePrices hata:', e);
  }
  // Fallback: localStorage
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(prices));
    // storage event tetiklemek için (aynı sekmede çalışmaz ama diğer sekmeler dinleyebilir)
    window.dispatchEvent(new StorageEvent('storage', { key: STORAGE_KEY, newValue: JSON.stringify(prices) }));
    return true;
  } catch {
    return false;
  }
}

export async function subscribePrices(callback) {
  const ok = await ensureFirebase();
  if (ok) {
    const unsubscribe = firebaseModules.onSnapshot(pricesDocRef, (snap) => {
      const data = snap.exists() ? snap.data() : {};
      callback(data || {});
    });
    return () => unsubscribe();
  }

  // Fallback: localStorage storage event
  const handler = () => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      callback(saved ? JSON.parse(saved) : {});
    } catch {
      callback({});
    }
  };
  window.addEventListener('storage', handler);
  // İlk değer
  handler();
  return () => window.removeEventListener('storage', handler);
}

// ---------- Auth Yardımcıları ----------
export async function signInAdmin(email, password) {
  const ok = await ensureFirebase();
  if (!ok) throw new Error('Firebase yapılandırması bulunamadı');
  return firebaseAuthModules.signInWithEmailAndPassword(auth, email, password);
}

export async function signOutAdmin() {
  if (!isFirebaseReady) return;
  return firebaseAuthModules.signOut(auth);
}

export async function onAuthChange(callback) {
  const ok = await ensureFirebase();
  if (!ok) {
    callback(null);
    return () => {};
  }
  return firebaseAuthModules.onAuthStateChanged(auth, (user) => callback(user));
}

export function getCurrentUser() {
  return auth ? auth.currentUser : null;
}


